export function pushDialog(dialog) {
  return {
    type: 'PUSH_DIALOG',
    dialog,
  };
}

export default {
  pushDialog,
};
